import { Injectable, Inject, EventEmitter, OnInit } from '@angular/core';
import { Http, Response, Headers } from '@angular/http';

import { Configuration } from '../configurations/shared.config';
import { SubscriberMetaData } from '../dataModels/';
import { IErrorHandler } from '../dataModels/contracts/IErrorHandler';

@Injectable()
export class AppConfigService {

    private _errorHandler: IErrorHandler;

    public ConfigLoaded: EventEmitter<any>;

    public Configurations: SubscriberMetaData;

    private subscriberConfiguration: any;

    constructor(private _http: Http, @Inject("IErrorHandler") handler: IErrorHandler/*, private _resourceService: ResourceService*/) {

        this._errorHandler = handler;

        this.ConfigLoaded = new EventEmitter<any>();

        this.Load();
  
    }

    public Load() {
        this._http.get(Configuration.urls.webApiEndpoint + Configuration.urls.appConfigUrl)
            .subscribe(response => {
                //Set Configurations
                this.Configurations = JSON.parse(response.text())
                //Emit Event
                this.ConfigLoaded.emit(this.Configurations);
            }, error => {

                //this._errorHandler.Handle(this._resourceService.Localize(Configuration.messages.defaultErrorMessage));
            });
    }

    //load Subscriber Configuration
     async loadSubscriberConfiguration(): Promise<any> {

        var response = await this._http.get(Configuration.urls.webApiEndpoint + Configuration.urls.appConfigUrl).toPromise()
            .then(response => {
                this.subscriberConfiguration = response ? JSON.parse(response.text()) : null
                    return this.subscriberConfiguration;
            })
            .catch(error => {
                //this._errorHandler.Handle(
                //this._errorHandler.Handle(this._resourceService.Localize(Configuration.messages.defaultErrorMessage)));
            });

        return response;
    }

    async getSubscriberConfiguration(): Promise<any> {
        if (!this.subscriberConfiguration) {
            await this.loadSubscriberConfiguration();
        }
        return this.subscriberConfiguration;
    }
    async forceLoadSubscriberConfiguration(): Promise<any> {
          return  await this.loadSubscriberConfiguration();  
    }

}


// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/services/app-config.service.ts